import MonthlySummaryError from './MonthlySummaryError';
class MonthlySummaryInvalidFiscalRegime extends MonthlySummaryError {
    fiscalRegime;
    constructor(fiscalRegime, options) {
        super('Fiscal regime code is not valid', options);
        this.fiscalRegime = fiscalRegime;
    }
}
export default MonthlySummaryInvalidFiscalRegime;
